// @ts-check
import cx from "classnames"
import PropTypes from "prop-types"
import React, { Component, Fragment } from "react"
import Block from "./Block"
// import BreadCrumb from "./BreadCrumb"
import { BlockContextConsumer } from "./ContextProviders"
import { TreeInstance } from "./tree/tree"

class RenderTree extends Component {
    state = {
        numberOfChanges: 0,
    }
    componentDidMount() {
        this.unsubscribe = this.props.instance.subscribe(() =>
            this.setState(({ numberOfChanges }) => ({ numberOfChanges: numberOfChanges + 1 }))
        )
    }
    componentWillUnmount() {
        this.unsubscribe()
    }
    render() {
        return (
            <BlockContextConsumer>
                {context =>
                    this.props.inline ? (
                        <Fragment>
                            {this.props.instance
                                .getBlocks()
                                .map(block => <Block element={block} key={block.id} />)}
                        </Fragment>
                    ) : (
                        <div
                            className={cx("renderTree", {
                                isEditing: context.editor.isEditing,
                                isDragging: context.dragDrop.isDragging,
                                hasDropTarget: context.dragDrop.hasDropTarget,
                            })}
                        >
                            <div className="flex-1" style={{ height: "100%" }}>
                                {this.props.instance
                                    .getBlocks()
                                    .map(block => <Block element={block} key={block.id} />)}
                            </div>
                        </div>
                    )
                }
            </BlockContextConsumer>
        )
    }
}

RenderTree.propTypes = {
    instance: PropTypes.instanceOf(TreeInstance).isRequired,
}

export default RenderTree



// WEBPACK FOOTER //
// ./src/features/editor/RenderTree.js